import WorkItemType from '@/domain/work-item/work-item-type.entity';

export default class WorkItemFilter {
  number?: number;

  title?: string;

  registerStartDate?: string;

  registerEndDate?: string;

  estimatedStartDate?: string;

  estimatedEndDate?: string;

  concludedStartDate?: string;

  concludedEndDate?: string;

  originCreatedStartDate?: string;

  originCreatedEndDate?: string;

  workItemType?: WorkItemType;

  originSystem?: string;

  status?: string;

  definitionType?: string;

  filterChildren: boolean = false;

  aggregatorsAndOrphanTasks: boolean = false;

  onlyChildren: boolean = false;

  member?: string;

  workItemFilterType: string = 'ALL';

  formatAllFields() {
    this.estimatedStartDate = this.format(this.estimatedStartDate);
    this.estimatedEndDate = this.format(this.estimatedEndDate);
    this.registerStartDate = this.format(this.registerStartDate);
    this.registerEndDate = this.format(this.registerEndDate);
    this.concludedStartDate = this.format(this.concludedStartDate);
    this.concludedEndDate = this.format(this.concludedEndDate);
    this.originCreatedStartDate = this.format(this.originCreatedStartDate);
    this.originCreatedEndDate = this.format(this.originCreatedEndDate);
  }

  private format(date?: string): string | undefined {
    if (date) {
      return new Date(date).toJSON();
    }
    return date;
  }
}
